import React from 'react';
import PropTypes from 'prop-types';
import s from './CricketScorecardV2.scss';

class MatchDetails extends React.Component {
  static propTypes = {
    match: PropTypes.shape({}).isRequired,
  };

  render() {
    const { match } = this.props;

    return (
      <div className={`${s.scorecardTable} ${s.matchDetails}`}>
        {match.umpires && <div className={s.tableHeading}>Match Details</div>}

        <ul>
          {match &&
            match.tosswonby && (
              <li className={s.tableItem}>
                <span>Toss</span>
                <span>{match.tosswonby}</span>
              </li>
            )}
          {match &&
            match.manOfTheMatch && (
              <li className={s.tableItem}>
                <span>Player of the Match</span>
                <span>{match.manOfTheMatch}</span>
              </li>
            )}
          {match &&
            match.umpires && (
              <li className={s.tableItem}>
                <span>Umpires</span>
                <span>{match.umpires}</span>
              </li>
            )}
          {match &&
            match.referee && (
              <li className={s.tableItem}>
                <span>Match referee</span>
                <span>{match.referee}</span>
              </li>
            )}
        </ul>
      </div>
    );
  }
}

export default MatchDetails;
